import React from 'react';
import { Alert, Typography } from '@mui/material';
import { PlayerCardLayout } from '../../components/PlayerCardLayout';
import { useT } from '../../localization/LocalizationProvider';

export function RoundCompletePage({ header, assignedLabel, completionMessage }) {
  const t = useT();
  return (
    <PlayerCardLayout header={header}>
      <Alert severity="success">{assignedLabel}</Alert>
      <Typography variant="h4">{t('Player.RoundComplete.Congrats')}</Typography>
      <Typography>{completionMessage}</Typography>
      <Typography>{t('Player.RoundComplete.PreparingUnlock')}</Typography>
    </PlayerCardLayout>
  );
}
